import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISaveTask, ITask, ITaskResult } from '../../models/tasks.interface';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { HttpClient } from '@angular/common/http';
import { ConsultationRecommendationService } from '../consultation-recommendation/consultation-recommendation.service';
import { RecommendationType } from '../../models/consultation-recommendation.model';

const STORAGE_KEY = 'recommendedTasks';

@Injectable({
  providedIn: 'root'
})
export class TasksService {
  private readonly tasksSubject = new BehaviorSubject<ITask[]>([]);
  tasks$ = this.tasksSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly injector: Injector
  ) {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      this.tasksSubject.next(JSON.parse(stored));
    }
  }

  notifyOpenDrawer() {
    //to avoid the circular dependency, using injector
    const consultationRecommendationService = this.injector.get(ConsultationRecommendationService);
    consultationRecommendationService.openDrawer(RecommendationType.Task);
  }

  setTasks(tasks: ITask[], isDataFromService = false) {
    this.tasksSubject.next(tasks);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tasks));

    if (isDataFromService && tasks.length) {
      this.notifyOpenDrawer();
    }
  }

  addTask(task: ITask) {
    const updated = [...this.tasksSubject.value, task];
    this.setTasks(updated);
  }

  toggleItem(index: number) {
    const items = [...this.tasksSubject.value];
    items[index].checked = !items[index].checked;
    this.setTasks(items);
  }

  updateTask(index: number, editTask: ITask) {
    if (index !== null) {
      const values = this.getTasks();

      let oldVal = values[index];
      oldVal = { ...oldVal, ...editTask }
      values[index] = oldVal
      this.setTasks(values);
    }
  }

  deleteTasks(index: number) {
    const tasks = [...this.tasksSubject.value];
    tasks.splice(index, 1);
    this.setTasks(tasks);
  }

  saveTasks(payload: ISaveTask): Observable<ITaskResult> {
    const url = `${environment.cva_url}${API_ROUTES.TASK}`;
    return this.http.post<ITaskResult>(url, payload)
  }

  generateTasks(
    transcript: string,
  ): Observable<{ response: { tasks: ITask[] } }> {
    return this.http.post<{ response: { tasks: ITask[] } }>(
      environment.cva_url + API_ROUTES.AI_PROXY + API_ROUTES.GENERATE_TASKS,
      { transcript }
    )
  }

  getTasks() {
    return this.tasksSubject.value;
  }

  clearAll() {
    this.setTasks([]);
  }
}
